<template>
  <div id="Pilotage" class="citypartner-container">
    <header class="header">
      <!-- <img src="./img/banner.jpg" alt=""> -->
      <div class="header-box">
        <div class="header-icon">
          <img src="./img/mifengxingyun_logo.png" alt="" />
          <img
            @click="toindex"
            class="toIndex"
            src="./img/yiche_logo.png"
            alt=""
          />
        </div>

        <div class="header-font">
          <img src="./img/zhutiziNew.png" alt="" />
        </div>

        <div class="header-line3">
          <div class="header-line3-text">新技术·新模式·持续收益·超高回报</div>
        </div>
      </div>
    </header>

    <div class="body-container">
      <div class="section1">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <img src="./img/dianzui_zuo.png" alt="" /> 智慧停车市场前景广阔
              <img src="./img/dianzui_you.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="section-content-desc">
            随着小汽车数量和机动车驾驶人的逐年增加，以及中国城镇化进程的不断推进，停车刚需体现得越来越突出，成为城市交通的一个明显痛点。国家和中央多个部委对此非常重视，不断出台一系列政策进行支持，停车场建设不仅成为新基建的一个核心板块，同时与停车管理相关的智慧社区/智慧交通/智慧城市也成为未来科技发展的重要方向。
            <br />另外，在5G、物联网、云计算、大数据等技术的推动下，各行各业的数字化方兴未艾，毫无疑问，未来针对停车场的智能改造与服务模式升级，将迎来设备更新、运营管理、线上支付、汽车后市场等多个领域的巨大机遇，市场前景广阔，想象空间无限。
          </div>
          <div class="section-content-bottom">
            <div>
              <p>2.5<span>亿辆+</span></p>
              <p>汽车保有量</p>
            </div>
            <div class="vertical">
              <div></div>
            </div>
            <div>
              <p>100<span>万座+</span></p>
              <p>停车场数量</p>
            </div>
            <div class="vertical">
              <div></div>
            </div>
            <div>
              <p>500<span>亿元+</span></p>
              <p>软硬件升级规模</p>
            </div>
            <div class="vertical">
              <div></div>
            </div>
            <div>
              <p>10000<span>亿元+</span></p>
              <p>停车费收入规模</p>
            </div>
          </div>
        </div>
      </div>

      <div class="section2">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <!-- <img src="./img/dianzui_zuo.png" alt="">【蜜蜂停车】引领互联网停车新模式&nbsp;&nbsp;<img src="./img/dianzui_you.png" alt=""> -->
              <img src="./img/mifeng.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="section-content-box">
            <div class="section-content-box-left">
              <img src="./img/mifengtingche_bg.png" alt="" />
            </div>
            <div class="section-content-box-right">
              <div class="img">
                <img src="./img/logo-mifengtingche.png" alt="" />
              </div>
              <div class="text">
                <div>
                  蜜蜂停车，是深圳市前海亿车科技有限公司旗下的互联网停车子品牌，专注于封闭式停车场的收费结算与运营管理，经过多年的自主研发创新，软硬件产品不断迭代完善，凭借雄厚的技术沉淀和丰富的经验积累，已成为国内领先的知名互联网停车服务平台。
                  <br />目前，蜜蜂停车已经覆盖全国各大城市，通过对管理运营和服务模式的创新，为数千家不同类型的停车场持续提供全方位、个性化的综合服务和技术赋能，帮助停车场业主大大降低了运营成本，规范了管理流程，并显著提高了停车费收入。
                </div>
              </div>
            </div>
          </div>

          <div class="line2">
            <div class="line2-text">
              蜜蜂停车基于强大的<span>“亿车 · 泊云”</span
              >和<span>“静态交通大脑”</span>智慧平台，依托物联网、云计算、人工智能等技术，推出的<span
                >“无人收费 + 云客服 + 智能感知 + 自动化运维 + 应急巡检”</span
              >综合解决方案，实现了完整的无人值守模式，全面支持车牌识别、无感支付、折扣优免、自助找零、电子发票、离线备份、大数据风控等一系列强大功能，不仅完美解决了各类管理漏洞，而且极大提升了用户体验。在快速发展的过程中，系统运行稳定，管理模式成熟，运营体系完善，已成为国内众多客户的首选合作伙伴。
            </div>
          </div>

          <div class="line3">
            <img src="./img/fegntingche.png" alt="" />
          </div>
        </div>
      </div>

      <div class="section3">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <img src="./img/dianzui_zuo.png" alt="" />
              与【星云联盟】分享数字经济新红利
              <img src="./img/dianzui_you.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="section-content-box">
            <div class="line1">
              【星云联盟】，是蜜蜂停车发起并打造的合伙人事业共建共享平台，旨在与全国各地志同道合的伙伴们一起优势互补，拓展市场，分享红利，蜜蜂停车通过技术、产品、运营、金融的赋能与全面支持，助力合作伙伴实现创业梦想。我们非常重视合伙人的权益保障和价值实现，合伙人渠道将是蜜蜂停车生态圈的重要角色，蜜蜂停车希望与合伙人共同成长，互助共赢。
              <br />停车行业仅仅是彼此合作的切入点，未来，【星云联盟】将不断延伸边界，拓展更多应用场景，向数字化社区整体解决方案及一系列服务落地进行演进，我们期待将各类创新的物联网硬件、平台运营、增值服务带来的庞大机遇，与所有合伙人分享，实现财富创造与人生价值的双丰收。
            </div>

            <div class="line2">
              <img src="./img/xinyunlianmeng.png" alt="" />
              <!-- <div class="cicle-line2" id="cicle1">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div>
              <div class="cicle-line2" id="cicle2">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div>
              <div class="cicle-line2" id="cicle3">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div>
              <div class="cicle-line2" id="cicle4">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div>
              <div class="cicle-line2" id="cicle5">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div>
              <div class="cicle-line2" id="cicle6">
                <p class="cicle-line2-1">超低门槛</p>
                <p class="cicle-line2-2">无需加盟费，总部扶持多</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="section4">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <img src="./img/dianzui_zuo.png" alt="" />
              多重权益保障助力合伙人开疆拓土
              <img src="./img/dianzui_you.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="section-content-box">
            <div class="line1">
              蜜蜂停车始终秉承“让客户成功，让伙伴受益，让用户获利”的多赢理念和利他主义思维，以开放心态为各方创造价值。我们将尽最大可能，为合伙人提供多维度的权益保障，营造更宽广、更自由的合作空间，输出更周到的全方位支持，以确保合伙人将精力和优势资源用于市场拓展，快速实现更大的事业版图。
            </div>

            <div class="line2">
              <div class="title">
                <div>首批合作的核心产品和服务</div>
              </div>
              <div class="content">
                <div class="picture">
                  <div><img src="./img/daozha.png" alt="" /></div>
                  <p>智能高速道闸</p>
                </div>
                <div class="picture">
                  <div><img src="./img/yitiji.png" alt="" /></div>
                  <p>车牌识别一体机</p>
                </div>
                <div class="picture">
                  <div><img src="./img/tongdoaji.png" alt="" /></div>
                  <p>智能云控通道机</p>
                </div>
                <div class="picture">
                  <div><img src="./img/yunpingtai.png" alt="" /></div>
                  <p>蜜蜂停车云平台</p>
                </div>
                <div class="picture">
                  <div><img src="./img/kefu.png" alt="" /></div>
                  <p>无人值守云客服</p>
                </div>
              </div>
            </div>

            <div class="line3">
              <div class="title">
                <div>城市合伙人的运营范围</div>
              </div>
              <div class="content">
                <img src="./img/section4-line3.png" alt="" />
              </div>
            </div>

            <div class="line4">
              <div class="title">
                <div>蜜蜂停车将提供的支持</div>
              </div>
              <div class="content">
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/pinpaishouquan.png" alt="" />
                  </div>
                  <p class="line4-box-1">品牌授权</p>
                  <p class="line4-box-2">获得蜜蜂停车品牌的使用权和运营权</p>
                </div>
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/kehuziyuan.png" alt="" />
                  </div>
                  <p class="line4-box-1">客户资源</p>
                  <p class="line4-box-2">
                    将当地的商业线索及客户资源推荐给合伙人
                  </p>
                </div>
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/peixunzhidao.png" alt="" />
                  </div>
                  <p class="line4-box-1">培训指导</p>
                  <p class="line4-box-2">
                    提供智慧停车业务的方案指导及各类培训
                  </p>
                </div>
              </div>
              <div class="content content2">
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/anlidazao.png" alt="" />
                  </div>
                  <p class="line4-box-1">案例打造</p>
                  <p class="line4-box-2">
                    根据项目合同帮助合伙人在当地建立标杆停车场案例
                  </p>
                </div>
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/fuwuzhichi.png" alt="" />
                  </div>
                  <p class="line4-box-1">服务支持</p>
                  <p class="line4-box-2">
                    提供市场宣传、售后服务、技术升级等各项支持
                  </p>
                </div>
                <div class="line4-box">
                  <div class="line4-box-img">
                    <img src="./img/rencaipeiyang.png" alt="" />
                  </div>
                  <p class="line4-box-1">人才培养</p>
                  <p class="line4-box-2">
                    为合伙人的企业或者团队定向培养技术与销售人才
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section5">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <!-- <img src="./img/dianzui_zuo.png" alt=""> 【星云联盟】计划招募详情 <img src="./img/dianzui_you.png" alt=""> -->
              <img src="./img/zhoamu.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="section-content-box">
            <div class="box box1">
              <div class="box-icon">
                <img src="./img/zhubanfang.png" alt="" />
              </div>
              <div class="box-right">
                <p class="one">招募主办方</p>
                <p class="two">
                  深圳市前海亿车科技有限公司（停车经营与数字社区事业部）
                </p>
              </div>
            </div>
            <div class="box box2">
              <div class="box-icon">
                <img src="./img/zhoamuquyu.png" alt="" />
              </div>
              <div class="box-right">
                <p class="one">招募区域</p>
                <p class="two">
                  首批开放招募100个名额（含：三线及以下城市级、一二线城市区县级），每个区域签约1个官方合伙人
                </p>
              </div>
            </div>
            <div class="box box3">
              <div class="box-icon">
                <img src="./img/zhoamushijian.png" alt="" />
              </div>
              <div class="box-right">
                <p class="one">招募时间</p>
                <p class="two">2019年9月1日 – 2019年12月31日</p>
              </div>
            </div>
            <div class="box" id="box4">
              <div class="box-icon">
                <img src="./img/zhoamuyaoqiu.png" alt="" />
              </div>
              <div class="box-right">
                <p class="one">招募要求</p>
                <p class="two">基本资质要求 :</p>
                <ul>
                  <li>符合国家相关法律法规，具备基本从业资格的企业或者个人</li>
                  <li>
                    有志于在停车行业长期发展，并认同蜜蜂停车的产品理念和商业模式
                  </li>
                  <li>
                    接受并同意蜜蜂停车的合作协议，并在协议相互约束的条款指导下开展业务
                  </li>
                  <li>
                    接受蜜蜂停车合伙人体系的相关管理规范、业务监督、市场指导和考核体系等等
                  </li>
                  <li>具备一定的项目投资能力，起步投资金额在5万元人民币以上</li>
                </ul>
                <p class="two">若有以下资质将优先招募:</p>
                <ul>
                  <li>
                    在本地拥有丰富、成熟的客户资源或客户关系（尤其是地产商、物业、政府关系，等等）
                  </li>
                  <li>自身现有业务能与停车板块形成协同</li>
                  <li>
                    对智慧停车、智慧社区以及物业信息化行业有深刻的认识和理解
                  </li>
                  <li>
                    具备一定的软硬件集成能力，可以开展总包或者独立实施项目
                  </li>
                  <li>具备一定的工程建设与售后服务能力</li>
                </ul>
              </div>
            </div>
            <div class="box" id="box5">
              <div class="box-icon">
                <img src="./img/hezuoliucheng.png" alt="" />
              </div>
              <div class="box-right">
                <p class="one">合作流程</p>
                <div class="list">
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/shenqingjiameng.png" alt="" />
                    </div>
                    <p>申请加盟</p>
                  </div>
                  <div class="arrow">
                    <div><img src="./img/jiantou.png" alt="" /></div>
                  </div>
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/zizhishenhe.png" alt="" />
                    </div>
                    <p>资质审核</p>
                  </div>
                  <div class="arrow">
                    <div><img src="./img/jiantou.png" alt="" /></div>
                  </div>
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/shangwuqiatan.png" alt="" />
                    </div>
                    <p>商务洽谈</p>
                  </div>
                  <div class="arrow">
                    <div><img src="./img/jiantou.png" alt="" /></div>
                  </div>
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/hetongqianding.png" alt="" />
                    </div>
                    <p>合同签订</p>
                  </div>
                  <div class="arrow">
                    <div><img src="./img/jiantou.png" alt="" /></div>
                  </div>
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/quanmianpeixun.png" alt="" />
                    </div>
                    <p>全面培训</p>
                  </div>
                  <div class="arrow">
                    <div><img src="./img/jiantou.png" alt="" /></div>
                  </div>
                  <div class="circle">
                    <div class="circle-icon">
                      <img src="./img/kaituoshichang.png" alt="" />
                    </div>
                    <p>开拓市场</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section6">
        <div class="section-title">
          <div class="section-title-bg">
            <div>
              <img src="./img/dianzui_zuo.png" alt="" /> 快速加盟通道
              <img src="./img/dianzui_you.png" alt="" />
            </div>
          </div>
        </div>

        <div class="section-content">
          <div class="line1">
            <p class="line1-1">电话垂询尊享一对一服务:</p>
            <p class="line1-2">VIP专人对接：</p>
          </div>
          <div class="line2">
            <div class="line2-one">
              <p class="icon"><img src="./img/kefu01.png" alt="" /></p>
              <p class="text">合作咨询热线:</p>
              <p class="mobile">400-111-8130</p>
            </div>
            <div class="line2-two">
              <div class="vertail-line"></div>
            </div>
            <div class="line2-three">
              <p class="icon"><img src="./img/wechat.png" alt="" /></p>
              <p class="wechat">微信扫码，在线咨询</p>
            </div>
            <div class="line2-four">
              <p class="line2-four-1">邓小姐 <span>渠道咨询顾问</span></p>
              <p class="line2-four-2">联系方式</p>
              <p class="line2-four-3">电话：132-6556-2186</p>
              <p class="line2-four-3">邮箱：nebula@ecaray.com</p>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom-icon">
            <img src="./img/yiche_dibulogo.png" alt="" />
          </div>
          <div class="bottom-desc">深圳市前海亿车科技有限公司</div>
        </div>
      </div>
    </div>

    <!-- <div @click="toindex">返回首页</div> -->
  </div>
</template>
<style lang="scss"></style>
<script>
import $ from 'jquery';
import videoPlayer from '@/components/video-player';
export default {
  data() {
    return {
      scroll: '',
      active: {
        background: '#eee',
      },
      searchBarFixed: false,
      showone: true,
      showtow: false,
      showthrid: false,
      showfor: false,
      sidle1: '',
      videlist: [],
      MIYao: '',
      accordion: false,
    };
  },
  //离开页面移除监听事件
  destroyed() {
    // window.removeEventListener('scroll', this.menu);
  },
  mounted() {
    this.$nextTick(function() {
      //滚动监听事件
      //   window.addEventListener('scroll', this.menu);
      var img = $('img');
      img.on('contextmenu', function() {
        return false;
      });
      img.on('dragstart', function() {
        return false;
      });
    });
  },
  methods: {
    toindex() {
      this.$router.push('/index');
    },
    //操作顶部tab
    setsailone(e) {
      var sidle1 = $('#setsailone').offset().top;
      $('html,body').animate({ scrollTop: sidle1 }, 800);
      if (e.target.getAttribute('data-silde') == '1') {
        this.showone = true;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = false;
      }
    },
    setsailtwo(e) {
      var lastesth_sidle2 = $('#setsailtwo').offset().top;
      $('html,body').animate({ scrollTop: lastesth_sidle2 }, 800);
      if (e.target.getAttribute('data-silde') == '2') {
        this.showone = false;
        this.showtow = true;
        this.showthrid = false;
        this.showfor = false;
        this.showfive = false;
      }
    },
    setsailth(e) {
      var rank_sidle3 = $('#setsailthird').offset().top;
      $('html,body').animate({ scrollTop: rank_sidle3 }, 800);
      if (e.target.getAttribute('data-silde') == '3') {
        this.showone = false;
        this.showtow = false;
        this.showthrid = true;
        this.showfor = false;
      }
    },
    setsailfor(e) {
      var fourth_silde4 = $('#setsailfou').offset().top;
      $('html,body').animate({ scrollTop: fourth_silde4 }, 800);
      if (e.target.getAttribute('data-silde') == '4') {
        this.showone = false;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = true;
      }
    },
    //监听滚动的事件
    menu() {
      var _self = this;
      _self.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var menuTop = document.querySelector('#pilotalBar').offsetTop;
      //滑动到指定位置菜单吸顶
      if (_self.scroll > menuTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      //滑动到指定位置相应菜单高亮
      var sidle2 = $('#setsailtwo').offset().top;
      var sidle3 = $('#setsailthird').offset().top;
      var sidle4 = $('#setsailfou').offset().top;
      if (_self.scroll < sidle2) {
        this.showone = true;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = false;
      } else if (_self.scroll < sidle3) {
        this.showone = false;
        this.showtow = true;
        this.showthrid = false;
        this.showfor = false;
      } else if (_self.scroll < sidle4) {
        this.showone = false;
        this.showtow = false;
        this.showthrid = true;
        this.showfor = false;
      } else if (_self.scroll > sidle3) {
        this.showone = false;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = true;
      }
    },
    Img() {
      videoPlayer({
        title: '了解亿车',
        width: '960',
        height: '494',
        // videoSrc:'',
      });
      //   videoSrc:
      //     'https://1253953386.vod2.myqcloud.com/vod-player/1253953386/5285890783637327356/tcplayer/console/vod-player.html?t=6d17af80&width=960&height=494&sign=ca636801fef462533beb3a2675c4944f',
      // });
    },
  },
};
</script>
<style lang="scss">
@keyframes mymove {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360);
  }
}
.citypartner-container {
  background: #2a3165;
  width: 100%;
  min-width: 1200px;

  .header {
    width: 100%;
    overflow: hidden;
    // position: relative;
    display: flex;
    justify-content: center;
    height: 720px;
    background: url('./img/banner.jpg');
    background-size: 100% 100%;

    .header-box {
      margin: 0 auto;
      width: 1200px;
      display: flex;
      // justify-content: center;
      align-items: center;
      flex-direction: column;
      .header-icon {
        width: 1176px;
        height: 40px;
        margin: 60px 0 134px 0;
        display: flex;
        justify-content: space-between;
        > img {
          display: block;
          // width: 100%;
        }
        .toIndex {
          cursor: pointer;
        }
      }

      .header-font {
        width: 1176px;
        margin-bottom: 60px;
        display: flex;
        justify-content: center;

        img {
          display: block;
          width: 1173px;
          height: 185px;
          margin-left: -2px;
        }
      }

      .header-line3 {
        width: 100%;
        display: flex;
        justify-content: center;

        .header-line3-text {
          width: 580px;
          // height: 60px;
          line-height: 60px;
          font-family: SourceHanSansCN-Normal;
          font-size: 30px;
          text-align: center;
          letter-spacing: 2px;
          color: #ffffff;
          border-radius: 0px 30px 0px 30px;
          border: solid 2px #ffffff;
          opacity: 0.8;
        }
      }
    }

    // background-size: 100% 100%;
  }

  .body-container {
    width: 100%;
    // height: 10189px;
    height: 10380px;
    background: url('./img/bg.jpg') no-repeat;
    background-size: 100% 100%;

    .section1 {
      width: 1200px;
      margin: 0 auto;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            font-weight: bold;
            letter-spacing: 1px;
            color: #ffffff;
            position: relative;
            top: -8px;
          }
        }
      }

      .section-content {
        width: 1200px;
        height: 484px;
        border-style: solid;
        border-width: 1px;
        border-image-source: linear-gradient(
          90deg,
          #ee753b 0%,
          #d6605c 0%,
          #bd4b7d 0%,
          #f7b868 100%
        );
        border-image-slice: 1;
        padding: 60px 40px;
        margin: 60px 0 51px 0;

        .section-content-desc {
          font-size: 18px;
          letter-spacing: 1px;
          line-height: 36px;
          color: #ffffff;
          opacity: 0.8;
          margin-bottom: 44px;
          text-align: justify;
        }
        .section-content-bottom {
          width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: space-between;

          .vertical {
            width: 88px;
            height: 132px;
            display: flex;
            justify-content: center;
            align-items: center;

            > div {
              width: 2px;
              height: 85px;
              background-color: #ffffff;
              opacity: 0.1;
            }
          }
          > div:nth-child(1) {
            width: 200px;

            p {
              text-align: center;
            }
          }
          > div:nth-child(3) {
            width: 200px;
            p {
              text-align: center;
            }
          }
          > div:nth-child(5) {
            width: 200px;
            p {
              text-align: center;
            }
          }
          > div:nth-child(7) {
            width: 252px;
            p {
              text-align: center;
            }
          }

          > div {
            // width: 252px;
            float: left;

            p:nth-child(1) {
              font-size: 60px;
              letter-spacing: -1px;
              color: #fdbb6b;

              span {
                font-size: 30px;
              }
            }
            p:nth-child(2) {
              font-size: 28px;
              color: #ffffff;
              opacity: 0.8;
            }
          }
        }
      }
    }

    .section2 {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 58px;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            letter-spacing: 1px;
            font-weight: bold;
            color: #ffffff;
            position: relative;
            top: -8px;
          }
        }
      }

      .section-content {
        width: 1200px;
        // height: 637px;
        // margin: 0 auto
        /*   display: flex;
        align-items: center;
        flex-direction: column; */

        .section-content-box {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 59px;

          .section-content-box-left {
            width: 658px;
            height: 637px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              display: block;
              //     width: 513px;
              // height: 474px;
              width: 658px;
              height: 637px;
              // width: 100%;
            }
          }

          .section-content-box-right {
            width: 418px;
            // height: 378px;
            margin-left: 60px;

            .img {
              margin: 69px 0 40px 0;
            }

            .text {
              font-size: 18px;
              letter-spacing: 1px;
              color: #ffffff;
              opacity: 0.8;
              line-height: 36px;
              font-family: MicrosoftYaHei;
              > div {
                text-align: justify;
              }
            }
          }
        }

        .line2 {
          height: 253px;
          overflow: hidden;
          // border-style: solid;
          // border-width: 1px;
          // border-image-source: linear-gradient(
          //   90deg,
          //   #ee753b 0%,
          //   #d6605c 0%,
          //   #bd4b7d 0%,
          //   #f7b868 100%
          // );
          background: url('./img/mftc_biankuang.png') no-repeat;
          background-size: 100% 100%;
          border-image-slice: 1;
          margin: 0 auto;
          // padding: 40px 42px 66px 42px;
          margin-bottom: 60px;

          .line2-text {
            font-family: MicrosoftYaHei;
            font-size: 18px;
            text-align: justify;
            line-height: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            opacity: 0.8;
            margin: 40px 40px;

            span {
              color: #fdbb6b;
            }
          }
        }

        .line3 {
          width: 1200px;
          height: 626px;
          margin: 0 auto;
          margin-bottom: 52px;
          display: flex;
          justify-content: center;

          img {
            display: block;
            width: 1200px;
            height: 616px;
          }
        }
      }
    }

    .section3 {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 66px;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            position: relative;
            top: -8px;
            font-weight: bold;
          }
        }
      }

      .section-content {
        width: 1200px;
        // height: 637px;
        margin: 0 auto;

        .section-content-box {
          width: 100%;
          // display: flex;
          // margin-bottom: 59px;

          .line1 {
            width: 1200px;
            height: 322px;
            // border-style: solid;
            // border-width: 1px;
            // border-image-source: linear-gradient(
            //   90deg,
            //   #ee753b 0%,
            //   #d6605c 0%,
            //   #bd4b7d 0%,
            //   #f7b868 100%
            // );
            // border-image-slice: 1;
            background: url('./img/xylm_biankuang.png') no-repeat;
            background-size: 100% 100%;
            font-size: 18px;
            line-height: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            opacity: 0.8;
            text-align: justify;
            padding: 40px;
            margin-bottom: 64px;
          }

          .line2 {
            width: 100%;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            margin: 0 auto;
            margin-bottom: 81px;
            // background: url('./img/xylm.png') no-repeat;
            // background-size: 100% 100%;
            // position: relative;
            display: flex;
            justify-content: center;

            img {
              display: block;
              // width: 678px;
              // height: 595px;
              width: 904px;
              height: 795px;
            }

            // .cicle-line2:hover {
            //   transform: scale(1.2);
            //   // transform: rotateX(120deg);
            //   // animation: mymove 1s infinite;
            // }

            // .cicle-line2 {
            //   width: 235px;
            //   height: 229px;
            //   background-color: #333b7a;
            //   // border-style: dotted;
            //   // border-width: 2px;
            //   // border-image-source: linear-gradient(
            //   //   0deg,
            //   //   #c0537d 0%,
            //   //   #f5b569 100%
            //   // );
            //   border-image-slice: 1;
            //   border: 2px dotted #c0537d;
            //   border-radius: 50%;
            //   display: flex;
            //   justify-content: center;
            //   align-items: center;
            //   flex-direction: column;

            //   position: absolute;
            //   top: -3px;
            //   left: 170px;

            //   .cicle-line2-1 {
            //     font-size: 24px;
            //     color: #ffffff;
            //     margin-bottom: 21px;
            //   }
            //   .cicle-line2-2 {
            //     font-size: 18px;
            //     color: #ffffff;
            //     opacity: 0.8;
            //     width: 136px;
            //   }

            // }

            //  #cicle2 {
            //    left: 500px;
            //  }
            //  #cicle3 {
            //   top: 246px;
            //   left: 0;
            //  }
            //  #cicle4 {
            //   top: 246px;
            //   left: 669px;
            //  }
            //  #cicle5 {
            //   top: 516px;
            //   left: 170px;
            //  }
            //  #cicle6 {
            //   top: 516px;
            //   left: 500px;
            //  }
          }
        }
      }
    }

    .section4 {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 60px;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            position: relative;
            top: -8px;
            font-weight: bold;
          }
        }
      }

      .section-content {
        width: 1200px;
        // height: 637px;
        margin: 0 auto;

        .section-content-box {
          width: 100%;
          // display: flex;
          // margin-bottom: 59px;

          .line1 {
            width: 100%;
            // height: 306px;
            font-size: 18px;
            line-height: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            opacity: 0.8;
            margin-bottom: 81px;
            text-align: justify;
          }

          .line2 {
            width: 100%;

            .title {
              width: 500px;
              height: 68px;
              background-image: linear-gradient(
                  90deg,
                  #ee753b 0%,
                  #d6605c 0%,
                  #bd4b7d 0%,
                  #f7b868 100%
                ),
                linear-gradient(#20324d, #20324d);
              background-blend-mode: normal, normal;
              border-radius: 0px 30px 0px;

              margin: 0 auto;
              overflow: hidden;

              > div {
                height: 68px;
                line-height: 68px;
                font-size: 30px;
                letter-spacing: 1px;
                color: #ffffff;
                text-align: center;
              }
            }

            .content {
              width: 100%;
              height: 350px;
              margin: 81px 0;
              display: flex;
              display: flex;
              // justify-content: center;
              // align-items: center;
              background-color: #333b7a;
              border-style: solid;
              border-width: 1px;
              border-image-source: linear-gradient(
                0deg,
                #bd4c7d 0%,
                #f6b668 100%
              );
              border-image-slice: 1;

              .picture {
                width: 20%;
                border-right: 1px solid #464d86;

                > div {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 67px 0 20px 0;
                  height: 207px;
                }

                p {
                  font-size: 14px;
                  letter-spacing: 0px;
                  color: #ffffff;
                  opacity: 0.8;
                  text-align: center;
                }
              }
            }
          }

          .line3 {
            width: 100%;

            .title {
              width: 500px;
              height: 68px;
              background-image: linear-gradient(
                  90deg,
                  #ee753b 0%,
                  #d6605c 0%,
                  #bd4b7d 0%,
                  #f7b868 100%
                ),
                linear-gradient(#20324d, #20324d);
              background-blend-mode: normal, normal;
              border-radius: 0px 30px 0px;

              margin: 0 auto;
              overflow: hidden;

              > div {
                height: 68px;
                line-height: 68px;
                font-size: 30px;
                letter-spacing: 1px;
                color: #ffffff;
                text-align: center;
              }
            }

            .content {
              width: 100%;
              // height: 350px;
              margin: 81px 0 80px 0;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                display: block;
                width: 1166px;
                height: 439px;
              }
            }
          }

          .line4 {
            width: 100%;

            .title {
              width: 500px;
              height: 68px;
              background-image: linear-gradient(
                  90deg,
                  #ee753b 0%,
                  #d6605c 0%,
                  #bd4b7d 0%,
                  #f7b868 100%
                ),
                linear-gradient(#20324d, #20324d);
              background-blend-mode: normal, normal;
              border-radius: 0px 30px 0px;

              margin: 0 auto;
              overflow: hidden;

              > div {
                height: 68px;
                line-height: 68px;
                font-size: 30px;
                letter-spacing: 1px;
                color: #ffffff;
                text-align: center;
              }
            }

            .content {
              width: 100%;
              // height: 350px;
              margin-top: 81px;
              display: flex;
              justify-content: space-between;
              // align-items: center;

              .line4-box {
                width: 300px;
                height: 340px;
                background-color: #333b7a;
                border-style: solid;
                border-width: 1px;
                border-image-source: linear-gradient(
                  0deg,
                  #bd4c7d 0%,
                  #f6b668 100%
                );
                border-image-slice: 1;
                .line4-box-img {
                  text-align: center;
                  margin: 63px 0 31px 0;
                }

                p {
                  text-align: center;
                  color: #ffffff;
                }
                .line4-box-1 {
                  font-size: 28px;
                  margin-bottom: 24px;
                }
                .line4-box-2 {
                  font-size: 18px;
                  opacity: 0.8;
                  width: 226px;
                  margin: 0 auto;
                }
              }
            }
            .content2 {
              margin: 60px 0 80px 0;
            }
          }
        }
      }
    }

    .section5 {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      margin-bottom: 80px;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 61px;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            position: relative;
            top: -8px;
          }
        }
      }

      .section-content {
        width: 1200px;
        // height: 1320px;
        margin: 0 auto;

        .section-content-box {
          width: 100%;
          background-color: #363e80;
          border-style: solid;
          border-width: 1px;
          border-image-source: linear-gradient(0deg, #bd4c7d 0%, #f6b668 100%);
          border-image-slice: 1;

          .box {
            width: 100%;
            height: 147px;
            display: flex;
            border-bottom: solid 1px #52598f;
            .box-icon {
              width: 180px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .box-right {
              width: 914px;
              margin: 30px 0;

              .one {
                font-size: 28px;
                letter-spacing: 1px;
                color: #ffffff;
                margin-bottom: 10px;
              }

              .two {
                font-size: 18px;
                letter-spacing: 1px;
                color: #ffffff;
                opacity: 0.64;
              }
            }
          }

          #box4 {
            height: 580px;

            .box-icon {
              align-items: flex-start;
              img {
                margin-top: 40px;
              }
            }
            .two {
              font-size: 24px;
              opacity: 0.8;
              margin-bottom: 14px;
            }
            ul {
              list-style: disc;
              margin: 0 0 40px 20px;

              li {
                font-size: 18px;
                letter-spacing: 1px;
                line-height: 30px;
                color: #ffffff;
                opacity: 0.64;
              }
            }
          }
          #box5 {
            height: 325px;

            .box-icon {
              align-items: flex-start;
              img {
                margin-top: 40px;
              }
            }

            .box-right {
              .one {
                margin-bottom: 41px;
              }
              .list {
                display: flex;

                .circle {
                  width: 100px;
                  height: 132px;

                  .circle-icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 21px;
                  }

                  p {
                    font-size: 24px;
                    letter-spacing: 1px;
                    color: #ffffff;
                    opacity: 0.8;
                  }
                }

                .arrow {
                  width: 60px;
                  height: 132px;

                  // align-items: center;
                  div {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;

                    img {
                      display: block;
                      width: 41px;
                      height: 4px;
                      margin-top: 45px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .section6 {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .section-title {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 58px;

        .section-title-bg {
          width: 1069px;
          height: 347px;
          background: url('./img/dabiaoti.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          > div {
            font-size: 36px;
            letter-spacing: 1px;
            color: #ffffff;
            position: relative;
            top: -8px;
            font-weight: bold;
          }
        }
      }

      .section-content {
        width: 1200px;
        // height: 350px;
        margin: 0 auto;
        background-color: #363e80;
        border-style: solid;
        border-width: 1px;
        border-image-source: linear-gradient(0deg, #bd4c7d 0%, #f6b668 100%);
        border-image-slice: 1;

        padding: 40px 89px;

        .line1 {
          width: 100%;
          display: flex;

          p {
            font-size: 18px;
            letter-spacing: 1px;
            color: #ffffff;
            opacity: 0.8;
            margin-bottom: 20px;
          }

          .line1-1 {
            width: 39%;
          }
        }

        .line2 {
          display: flex;
          width: 1022px;
          height: 234px;
          background-color: #ffffff;
          border-radius: 10px;
          margin: 0 auto;

          .line2-one {
            width: 320px;
            text-align: center;

            .icon {
              margin: 39px 0 20px 0;
            }

            .text {
              font-size: 18px;
              color: #2a3165;
              opacity: 0.8;
              margin-bottom: 5px;
            }
            .mobile {
              font-size: 30px;
              color: #2a3165;
              font-weight: bold;
            }
          }
          .line2-two {
            width: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            .vertail-line {
              width: 2px;
              height: 100px;
              background-color: #2a3165;
              opacity: 0.42;
            }
          }
          .line2-three {
            width: 300px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .wechat {
              font-size: 18px;
              color: #2a3165;
              opacity: 0.6;
            }
          }
          .line2-four {
            width: 300px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            // align-items: center;
            color: #2a3165;
            //  text-align:

            .line2-four-1 {
              font-size: 30px;
              font-weight: bold;

              margin-bottom: 30px;

              span {
                font-size: 18px;
                font-weight: normal;
              }
            }

            .line2-four-2 {
              font-size: 18px;
              margin-bottom: 5px;
            }

            .line2-four-3 {
              font-size: 18px;
            }
          }
        }
      }

      .bottom {
        width: 600px;
        margin: 0 auto;
        display: flex;
        margin-top: 40px;

        .bottom-icon {
          width: 160px;
          height: 40px;
        }

        .bottom-desc {
          width: 405px;
          height: 40px;
          line-height: 40px;
          font-size: 30px;
          letter-spacing: 1px;
          color: #ffffff;
          opacity: 0.5;
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
